module.exports = __webpack_public_path__ + "img/ap209.ce6143fa.jpg";